<script>
export default {
   data () {
    return {
      lessonData: {}
    }
  },
  methods: {
    saveAndExit () {
      if (this.open) {
        this.$vs.notify({
          title: 'Nice job!',
          text: `You have completed a session: <span class="font-bold">${this.lessonTitle}</span>.`,
          iconPack: 'feather',
          icon: 'icon-book-open',
          color: 'dark',
          time: 8000,
          position: 'bottom-center'
        })
      }

      this.$store.dispatch('UPDATE_LESSON', { lesson: this.lesson, updateFields: { status: 'completed', lessonData: this.lessonData, completedAt: (new Date) } })
      this.$emit('hidePopup')
      return true
    },
  },
  computed: {
    lessonTitle () {
      return this.lesson.title
    },
    open () {
      return this.lesson.status === 'open'
    },
    openFinishButton () { return 'complete' },
    completedFinishButton () { return 'close' },
    buttonTitle () {
      if (this.open) {
        return this.openFinishButton
      } else {
        return this.completedFinishButton
      }
    }
  },
  mounted () {
    if (this.lesson && this.lesson.lessonData) this.lessonData = { ...this.lesson.lessonData }
  }
}
</script>
